// Configuration for production deployment
// Updated with actual API Gateway URL from CDK deployment
export const API_CONFIG = {
  // Your actual API Gateway URL from CDK output
  API_URL: 'https://ekdxh5722g.execute-api.us-east-1.amazonaws.com/prod',
  
  // You can add other config values here
  ENVIRONMENT: process.env.NODE_ENV || 'production'
};

export default API_CONFIG; 